import { Model } from "@vuex-orm/core";
import config from "../configs/Tag";
import ResolutionCatalogTag from "./ResolutionCatalogTag";

export default class Tag extends Model {
  static get entity() {
    return "tags";
  }
  static fields() {
    return {
      // HACK: to update ManyToMany in API Platform
      // "@id": this.attr(null),
      id: this.attr(null),
      agency_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      resolution_catalog_tags: this.hasMany(ResolutionCatalogTag, "tag_id"),
    };
  }
  static get apiConfig() {
    return config;
  }
}
